export default class Overlay {
    constructor(elementSelector, styleOnEnable = null) {
        this.styleOnEnable = styleOnEnable || 'position: fixed; width: 100%; overflow: hidden;';
        this.scrollPosition = 0;
        this.enabled = false;
        this.elementSelector = elementSelector;
    }

    getElement(elementSelector) {
        return document.querySelector(elementSelector);
    }

    enable() {
        if (this.enabled)
            return;

        const element = this.getElement(this.elementSelector);

        this.scrollPosition = window.pageYOffset;

        if (element !== null) {
            this.enabled = true;
            this.originalStyle = element.style.cssText;
            element.style.top = `-${ this.scrollPosition }px`;
            element.style.cssText = element.style.cssText + this.styleOnEnable;
        }
    }

    disable() {
        if (!this.enabled)
            return;

        const element = this.getElement(this.elementSelector);

        if (element !== null) {
            this.enabled = false;
            element.style.cssText = this.originalStyle;
            element.style.top = 'auto';

            window.scrollTo(0, this.scrollPosition);
        }
    }
}